import applySidebarOrganizationOperations from './applySidebarOrganizationOperations.js';

const applyCommittedSidebarPlacement = ({ state, commit, settledAt } = {}) => {
  const sidebarType = String(commit?.sidebarType || '').trim();
  const scopeCompanyId = String(commit?.scopeCompanyId || '').trim();
  const placement = commit?.placement;
  const hasLocation = Boolean(placement?.groupId) !== Boolean(placement?.sectionKey);
  const currentOrganization = state?.sidebarOrganizationByType?.[sidebarType];

  if (!sidebarType || !scopeCompanyId || !placement?.itemType || !placement?.itemId || !hasLocation || currentOrganization?.scopeCompanyId !== scopeCompanyId) {
    return state;
  }

  const serverSnapshot = state.sidebarOrganizationServerPayloadByType?.[sidebarType] || currentOrganization;
  const placements = [...(Array.isArray(serverSnapshot?.placements) ? serverSnapshot.placements : [])];
  const existingIndex = placements.findIndex((candidate) => candidate?.itemType === placement.itemType && candidate?.itemId === placement.itemId);

  if (existingIndex >= 0) {
    placements[existingIndex] = placement;
  } else {
    placements.push(placement);
  }

  const nextServerSnapshot = {
    ...serverSnapshot,
    placements
  };
  const pendingMutations = state.sidebarOrganizationPendingMutations.filter((pendingMutation) => pendingMutation.sidebarType === sidebarType);
  const normalizedSettledAt = Number(settledAt) || Date.now();

  return {
    ...state,
    sidebarOrganizationServerPayloadByType: {
      ...state.sidebarOrganizationServerPayloadByType,
      [sidebarType]: nextServerSnapshot
    },
    sidebarOrganizationLastSettledLocalChangeAtByType: {
      ...state.sidebarOrganizationLastSettledLocalChangeAtByType,
      [sidebarType]: Math.max(Number(state.sidebarOrganizationLastSettledLocalChangeAtByType?.[sidebarType] || 0), normalizedSettledAt)
    },
    sidebarOrganizationByType: {
      ...state.sidebarOrganizationByType,
      [sidebarType]: applySidebarOrganizationOperations({ snapshot: nextServerSnapshot, pendingMutations })
    }
  };
};

export default applyCommittedSidebarPlacement;
